const Footer = () => {
    return(
        <footer className="pb-2">
            <span className="pl-2">Acepto terminos y condiciones de envios; y la ley de proteccion de datos registrados en la pagina web: 
                <a className="text-primary" target="_blank" href="https://www.exactocarga.com"> www.exactocarga.com</a> 
            </span>
        </footer>
    )
}

export default Footer